export const OVERLAY_MOBILE_GAP = 10;
export const OVERLAY_MAX_WIDTH = 462;
export const TOOLTIP_GAP = 15;
export const ARROW_HEIGHT = 12;
export const ARROW_WIDTH = 18;
// Icon does some weird placement, therefore all these values are different. Please feel free to improve if you have a better solution
export const ARROW_TOP_OFFSET = 4;
export const ARROW_RIGHT_OFFSET = 6;
export const ARROW_BOTTOM_OFFSET = 6;
export const ARROW_LEFT_OFFSET = 4;
export const TOOLTIP_ICON_SIZE = 'lg';
